import { apiRequest, readJsonOrThrow } from "@/api/client";

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, String(value));
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : "";
}

export async function fetchEmailMarketingSummary(session) {
  const response = await apiRequest("/momo/email-marketing/summary", {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to fetch email marketing summary");
}

export async function fetchEmailMarketingStates(session, params = {}) {
  const response = await apiRequest(`/momo/email-marketing/states${buildQuery(params)}`, {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to fetch email marketing states");
}

export async function previewEmailMarketing(session, payload) {
  const response = await apiRequest("/momo/email-marketing/preview", {
    method: "POST",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to preview email marketing");
}

export async function syncEmailMarketingCandidates(session, params = {}) {
  const response = await apiRequest(`/momo/email-marketing/sync-candidates${buildQuery(params)}`, {
    method: "POST",
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to sync email marketing candidates");
}
